<template>
  <div>
    <title-bar title="设备软件升级">
      <el-button type="default" @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <div class="base-info">
        <h1>设备软件升级【{{deviceCode}}】</h1>
        <span class="boot-info">最新版本：V{{versionInfo.versionName}}</span>
        <span class="boot-info">发布时间：{{versionInfo.publishTime}}</span>
        <span class="boot-info">包大小：{{versionInfo.packageLength}}字节</span>
        <span class="boot-info">包个数：{{versionInfo.packageCount}}个</span>
        <el-button type="primary" @click="update" :loading="loading">开始升级</el-button>
      </div>
      <div class="blocks">
        <div v-for="item of packages" :key="item.index" :class="item.css"></div>
      </div>
      <div class="logs">
        <div v-for="(item,index) of logs" :key="index" :class="item.success?'':'color-error'">
          {{item.msg}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import BaseVue from "@/components/base/BaseVue";
export default {
  components: { TitleBar},
  extends: BaseVue,
  data() {
    return {
      socket: null,
      deviceCode: this.$route.query.deviceCode,
      versionInfo:{
        packageCount: 0
      },
      heartCheck:null,
      packages: [],
      logs: []
    }
  },
  created() {
    this.postForm("/boot-version/last-version-info",{},true).then((dr)=>{
      this.versionInfo = dr.bean;
      for(let i=0;i<this.versionInfo.packageCount;i++) {
        this.packages.push({
          index: i,
          //包状态：0未发送，1已发送，2成功，3失败
          css: "block"
        });
      }
    });

    //websocket心跳包，保证websocket连接不中断
    this.heartCheck = {
      timeout: 30000,//30秒
      timeoutObj: null,
      reset: () => {
        clearInterval(this.heartCheck.timeoutObj);
      },
      start: () => {
        this.heartCheck.timeoutObj = setInterval(() => {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          this.socket.send("HeartBeat");
          console.log("send 'HeartBeat'");
        }, this.heartCheck.timeout)
      }
    }

    this.socket = new WebSocket(this.globalConfig.wsRoot+"/device-update/"+this.deviceCode);
    //打开事件
    this.socket.onopen = () => {
      console.log("连接已经建立");
      this.heartCheck.start();
    };
    //获得消息事件
    this.socket.onmessage = (msg) => {
      console.log(msg.data);
      let status = JSON.parse(msg.data);
      if(!status.success) {
        this.loading = false;
      }
      if(status.what == "sendPackage"){
        this.packages[status.packageIndex].css = "block sended";
      }else if(status.what == "sendPackageReceive"){
        if(status.success){
          this.packages[status.packageIndex].css = "block error";
        }else{
          this.packages[status.packageIndex].css = "block success";
        }
      }else {
        this.logs.push(status);
      }
    };
    //关闭事件
    this.socket.onclose = () => {
      this.heartCheck.reset();
      console.log("Socket已关闭");
    };
    //发生了错误事件
    this.socket.onerror = (e) => {
      console.error(e);
    }
  },
  beforeDestroy() {
    if(this.socket != null) {
      this.socket.close();
    }
  },
  methods: {
    //升级
    update(){
      this.$confirm("确定要升级吗？","系统提示").then(()=>{
        this.loading = true;
        this.postForm("/boot-version/update",{
          deviceCode: this.deviceCode
        },true);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.base-info {
  span.boot-info{
    margin-right: 20px
  }
}
.blocks{
  margin-top: 30px;
  .block{
    display:inline-block;
    width: 20px;
    height: 20px;
    border-width: 1px 1px 1px 0px;
    border-style: solid;
    border-color: #00458A;
  }
  .block.sended{
    background-color:#1E9FFF;
  }
  .block.success{
    background-color:#009688 !important;
  }
  .block.error{
    background-color:#FF5722 !important;
  }
}
.logs {
  margin-top:10px;
  div{
    line-height: 26px;
  }
}
</style>